export const PLANS = [
  {
    id: "plan_free",
    name: "Free",
    tagline: "Découverte",
    accent: "slate",
    icon: "Sparkles",
    monthly: 0,
    yearly: 0,
    credits: 0,
    features: [
      "Profil de base",
      "1 produit en vente sur la marketplace",
      "Accès à la communauté",
      "Aucun crédit IA inclus",
    ],
  },
  {
    id: "plan_debutant",
    name: "Débutant",
    tagline: "Pour démarrer",
    accent: "emerald",
    icon: "Rocket",
    monthly: 29,
    yearly: 290,
    credits: 250,
    features: [
      "250 crédits / mois",
      "AIBA Chat, Writer & Images",
      "UGC Studio",
      "Voix de base",
      "1 Clone IA",
    ],
  },
  {
    id: "plan_expert",
    name: "Expert",
    tagline: "Passe au niveau supérieur",
    accent: "blue",
    icon: "Star",
    monthly: 49,
    yearly: 490,
    credits: 1000,
    features: [
      "Tout Débutant, +",
      "1 000 crédits / mois",
      "Génération vidéo IA",
      "Analytic Hub & SEO",
      "2 Clones IA",
    ],
  },
  {
    id: "plan_premium",
    name: "Premium",
    tagline: "L'expérience complète",
    accent: "blue",
    recommended: true,
    icon: "Crown",
    monthly: 99,
    yearly: 990,
    credits: 2500,
    features: [
      "Tout Expert, +",
      "2 500 crédits / mois",
      "AIBA Suite (orchestration)",
      "Bot d'automatisation",
      "5 Clones IA · Support prioritaire",
    ],
  },
  {
    id: "plan_pro",
    name: "AIBA Pro",
    tagline: "Pour les agences & pros",
    accent: "orange",
    icon: "Rocket",
    monthly: 199,
    yearly: 1990,
    credits: 6000,
    features: [
      "Tout Premium, +",
      "6 000 crédits / mois",
      "Vidéos longues (à venir)",
      "Traitement prioritaire & branding",
      "10 Clones IA",
    ],
  },
];

export const SERVICES = [
  {
    id: "svc_studio",
    name: "AIBA Studio",
    tagline: "Création sur-mesure",
    accent: "blue",
    icon: "Code2",
    price: 3200,
    unit: "Paiement unique",
    cta: "Commander maintenant",
    features: [
      "Site web ou application complète sur-mesure",
      "Questionnaire détaillé et analyse des besoins",
      "Design, développement et livraison clé en main",
      "Tableau de bord de suivi en temps réel",
      "Documentation, guide et code source",
    ],
  },
  {
    id: "svc_session",
    name: "Session 1:1",
    tagline: "Coaching personnalisé",
    accent: "orange",
    icon: "UserRound",
    price: 200,
    unit: "/ session",
    cta: "Réserver une session",
    features: [
      "Session personnalisée de 2h",
      "Coaching 1:1 avec un expert AIBA",
      "Plan d'action sur-mesure",
      "Suivi de tes projets",
      "Réponses à toutes tes questions",
    ],
  },
  {
    id: "svc_educateur",
    name: "Éducateur IA",
    tagline: "Enseigne à ton tour",
    accent: "blue",
    icon: "GraduationCap",
    price: 575,
    unit: "/ formation",
    cta: "Devenir éducateur",
    features: [
      "Formation complète pour devenir éducateur IA",
      "Certification officielle AIBA Éducateur",
      "Droit d'enseigner sur la plateforme AIBA",
      "Outils et templates pédagogiques inclus",
      "Mise en relation avec la communauté",
    ],
  },
];
